import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Life poses endless ‘gambles’. Each and every day, we weigh up the
                                                pros and cons of multiple options
                                                before arriving at our decisions. This tool is about<span
                                                    className="brown brownbold"> how to know when and how to take risks</span> and
                                                provides advice on determining your own level of risk-taking
                                                behaviour and how this might impact on
                                                your decisions.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>WHAT IS RISK TAKING?
                                            </div>
                                            <p>We're not talking about the 2.30 at Kempton Park, but without
                                                taking risks we'd be nowhere. Every
                                                day presents us with a variety of risks to assess – we've been
                                                doing it since we were born. Our
                                                experiences and personality shape our adult approach but here
                                                we'll help you consider whether
                                                yours helps or hinders you in the workplace and how you can
                                                maximise your chances of successful
                                                risk taking.</p>
                                            <p>The adrenalin junkies amongst us are exhilarated by
                                                unpredictability, others unsettled by it or ‘risk
                                                averse’. Whichever extreme you think you tend towards seems to
                                                depend on the amount of
                                                information you need before making a decision and how quickly
                                                you make it.<a className="superscripttext"
                                                               href="further_info.php?course=300"><sup>2</sup></a> Psychologists
                                                assess
                                                the likelihood of us taking risks according to personality – if
                                                we're conventional and abide by rules
                                                and norms we're less likely to be risk takers than those who are
                                                impulsive, spontaneous or
                                                entrepreneurial. However, a taste for risk taking doesn't
                                                indicate an instinct for successful decision
                                                making! Being successful as an individual or an organisation
                                                isn't a matter of ‘nothing ventured
                                                nothing gained' – it's about knowing when and how to take risks
                                                to maximise their chances
                                                of success.
                                            </p>
                                            <div className="border_subtitle">Approaches to risk taking</div>
                                            <div className="uiheading"><p>People have three broad approaches to
                                                risk taking or ‘risk orientation':<a className="superscripttext"
                                                                                     href="further_info.php?course=300"><sup>3</sup></a>
                                            </p></div>
                                            <ul className="greenbullet-list">
                                                <li>Risk avoiders: those who won't take any if they can help
                                                    it
                                                </li>
                                                <li>Risk reducers: those who do things in spite of the risk
                                                    involved
                                                </li>
                                                <li>Risk optimisers: those who do things specifically because of
                                                    the risk involved.
                                                </li>
                                            </ul>

                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/graph-risk.png')}
                                                    alt=""/>

                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}